import styled from 'styled-components';

export const AccordionContainer = styled.div``;

export const AccordionBox = styled.div`
  display: flex;
  flex-direction: column;
  border-width: 1px 0 0px 0;
  border-style: solid;
  border-color: #9c9c9c;

  &:last-child {
    border-bottom-width: 1px;
  }
`;

export const AccordionAngle = styled.div`
  font-size: 14px;
  transition: 0.4s;
  margin-right: 5px;

  &.active {
    transform: rotate(90deg);
  }
`;

export const AccordionTitle = styled.div`
  color: #007db8;
  display: flex;
  align-items: center;
  font-size: 14px;
  padding: 13px 10px;
  cursor: pointer;
`;

export const AccordionContent = styled.div`
  padding: 0 0 0 28px;
  overflow: hidden;
  max-height: 0;
  min-height: 0;
  transition: 0.4s;

  &.active {
    min-height: 20px;
    max-height: 100vh;
  }
`;
